import type { VoidFunctionComponent } from 'react';

import { useParams } from '../../../../contexts/RouterContext';
import { useCurrentProject } from '../../../../hooks/api/projects/useCurrentProject';
import { useCurrentRevision } from '../../../../hooks/api/revisions/useCurrentRevision';
import { getProjectBaseURLFromParams } from '../../../../utils';
import Loader from '../../../generic/Loader';
import Panel from '../../../generic/Panel';
import { projectTypes } from '../../shared/projectTypesIconMap';
import type { RevisionRouteParams } from '../../projectDashboardTypes';

import { IssuesBar } from './IssuesBar/IssuesBar';
import { ProjectSummaryV2Heading } from './ProjectSummaryV2Heading';

import styles from './ProjectSummaryV2.module.less';

export const ProjectSummaryV2: VoidFunctionComponent = () => {
  const params = useParams<RevisionRouteParams>();
  const { data: project, isLoading: isProjectLoading } = useCurrentProject();
  const { data: revision } = useCurrentRevision();
  const revisionLocator = revision?.locator;

  if (!project || isProjectLoading) {
    return (
      <div className="padding-top-sm container">
        <Loader />
      </div>
    );
  }

  const projectTypeTitle = (project.type && projectTypes[project.type]) ? projectTypes[project.type].title : 'Other';
  const baseRevisionURL = getProjectBaseURLFromParams({
    ...params,
    reference_type: params.reference_type || 'branch',
    reference: (params.reference || project.default_branch) ?? 'master',
    revision_id: params.revision_id,
  });

  return (
    <div className="padding-top-xl container">
      <Panel>
        <ProjectSummaryV2Heading
          projectTypeTitle={projectTypeTitle}
          revisionLocator={revisionLocator}
          baseRevisionURL={baseRevisionURL}
        />
        <div className={styles.summaryGrid}>
          <IssuesBar />
        </div>
      </Panel>
    </div>
  );
};
